import { dataConstants } from '../../src/constants';
import _getWideScreenerMetrics from "../../lib/screener/_getScreenerMetrics";
import _getWideScreenerMetricsCount from "../../lib/screener/_getScreenerMetricsCount";
import getPageMetaTags from "../../lib/meta/_getMetaTags";
import _getScreens from "../../lib/screener/userOperations/_getScreens";
import { getFormula } from "../../src/components/Screener/QueryBuilder/typeahead.util";
import useScreenerState from "../../src/hook/useScreenerState";
import ScreenerLayout from "../../src/components/Screener/ScreenerLayout";

const ScreenerPage = (props) => {
  const {
    _screenerMetrics, _screenerMetricsCount, _tableColumns,
    _formula, _criteria, _screenName, _screenDesc, _screenCode, _screens,
  } = props || {};

  const state = useScreenerState({
    screens: _screens,
    initialMetrics: _screenerMetrics,
    initialCount: _screenerMetricsCount,
    initialFormula: _formula,
    initialCriteria: _criteria,
    initialPresetName: _screenName,
    initialPresetDesc: _screenDesc,
    initialPresetCode: _screenCode,
    initialTableColumns: _tableColumns,
    mode: 'preset',
  });

  return (
    <ScreenerLayout
      state={state}
      pageProps={props}
      breadcrumbs={[
        { label: 'Stock Screener', href: '/stock-screener' },
        { label: state.activePresetName || _screenName || 'Screen' },
      ]}
      pageTitle={state.activePresetName || _screenName || 'Stock Screener'}
      pageDesc={state.activePresetDesc || _screenDesc}
      mode="preset"
    />
  );
};

export async function getStaticPaths() {
  const { getScreens } = await _getScreens("") || {};
  return {
    paths: getScreens && getScreens?.length > 0 ? getScreens?.map(screen => ({
      params: { screen: `${screen?.code}` },
    })) : [],
    fallback: 'blocking'
  }
}

export async function getStaticProps({ params, tabCode = "SCREEN", preview = false, type = "screen", _ = '' }) {
  const first = 100; const offset = 1; const andor = 'AND';
  const { getScreens } = await _getScreens("") || {};
  let { criteria, columns, screen_name, screen_desc, code } = getScreens?.find(d => d?.code === params?.screen) ?? ''
  if (!columns?.includes('ticker') && !columns?.includes('tickername')) {
    columns = columns?.replace('[', "['ticker','tickername',");
  } else if (!columns?.includes('ticker')) {
    columns = columns?.replace('[', "['ticker',");
  } else if (!columns?.includes('tickername')) {
    columns = columns?.replace('[', "['tickername',");
  }
  const _columns = columns?.replace(/\|/g, '__')?.replace(/\./g, '_') || "";
  const _formula = getFormula(criteria?.replace(/[()"]/g, '')?.replace(/AND/g, 'AND\n')?.replace(/ and /g, ' AND\n')?.replace(/ or /g, ' OR '), dataConstants?.DEFAULT_TBL_COLS?.sort((a, b) => b?.name?.length - a?.name?.length)) || []
  const { getWideScreenerMetricsV3: screenerMetrics } = await _getWideScreenerMetrics(andor, _formula, first, offset) || {}
  const { getWideScreenerMetricsCountV3: screenerMetricsCount } = await _getWideScreenerMetricsCount(andor, _formula) || {}
  const meta_tags = (await getPageMetaTags(`/stock-screener/${params?.screen}`, false)) || {}
  const { getMetaTags } = meta_tags || {}
  return {
    props: {
      _screenerMetrics: screenerMetrics || null,
      _screenerMetricsCount: screenerMetricsCount || null,
      _tableColumns: _columns,
      _formula: _formula,
      _criteria: criteria || "",
      _screenName: screen_name || "",
      _screenDesc: screen_desc || "",
      _screenCode: code || "",
      activeScreen: params?.screen,
      _screens: getScreens || [],
      meta_tags: getMetaTags?.tags || null
    },
    revalidate: dataConstants.REVALIDATE_IN.DEFAULT_HOURS,
    notFound: params?.screen === code ? false : true,
  }
}

export default ScreenerPage;
